module.exports = __webpack_public_path__ + "static/ProfileConnor-2a28a10843233a0049f3685a3d88ae06.jpg";